function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { disabledStateUpdate, optionsUpdate, searchForOptions } from '@engine/actions/creators/async-select-multi';
import React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
var WAIT = 750;

var AsyncSelectMulti = /*#__PURE__*/function (_React$Component) {
  _inherits(AsyncSelectMulti, _React$Component);

  var _super = _createSuper(AsyncSelectMulti);

  function AsyncSelectMulti(props) {
    var _this;

    _classCallCheck(this, AsyncSelectMulti);

    _this = _super.call(this, props);
    _this.state = {
      value: _this.props.value,
      isMenuOpen: false
    };

    _this.props.optionsUpdate(_this.props.defaultOptions, _this.props.id);

    _this.props.disabledStateUpdate(_this.props.disabled, _this.props.id);

    _this.timeout = null;
    _this.locales = {
      loading: I18n.t('object.status.loading'),
      noOptions: I18n.t('javascript.async_multi_select.no_options'),
      placeholder: I18n.t('actions.default.please_select'),
      somethingWentWrong: I18n.t('javascript.errors.something_went_wrong'),
      tryAgainLater: I18n.t('javascript.errors.try_again_later'),
      termMessage: I18n.t('javascript.async_multi_select.term_message', {
        min_search_length: _this.props.minSearchLength
      })
    };

    if (_this.props.prefetch) {
      _this.props.searchForOptions(_this.props.url, {
        term: ''
      }, _this.props.id);
    }

    return _this;
  }

  _createClass(AsyncSelectMulti, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Select, {
        className: "async-select-multi ".concat(this.state.isMenuOpen ? 'opened' : ''),
        id: this.props.id,
        defaultValue: this.props.value,
        isDisabled: this.props.isDisabled,
        isLoading: this.props.isSearching,
        isMulti: this.props.isMulti,
        loadingMessage: function loadingMessage() {
          return _this2.locales.loading;
        },
        name: this.props.name,
        noOptionsMessage: function noOptionsMessage(inputValue) {
          return _this2.noOptionsMessage(inputValue);
        },
        onChange: function onChange(values) {
          return _this2.updateValue(values || []);
        },
        onInputChange: function onInputChange(inputValue) {
          return _this2.inputChange(inputValue);
        },
        onMenuClose: function onMenuClose() {
          return _this2.menuClose();
        },
        onMenuOpen: function onMenuOpen() {
          return _this2.menuOpen();
        },
        options: this.props.options,
        placeholder: this.locales.placeholder,
        value: this.state.value
      });
    }
  }, {
    key: "inputChange",
    value: function inputChange(inputValue) {
      var _this3 = this;

      clearTimeout(this.timeout);

      if (inputValue.length < this.props.minSearchLength) {
        return;
      }

      this.timeout = setTimeout(function () {
        _this3.props.searchForOptions(_this3.props.url, {
          term: inputValue
        }, _this3.props.id);
      }, WAIT);
    }
  }, {
    key: "menuClose",
    value: function menuClose() {
      this.setState({
        isMenuOpen: false
      });
    }
  }, {
    key: "menuOpen",
    value: function menuOpen() {
      this.setState({
        isMenuOpen: true
      });
    }
  }, {
    key: "noOptionsMessage",
    value: function noOptionsMessage(inputValue) {
      if (this.props.hasError) {
        return "".concat(this.locales.somethingWentWrong, " ").concat(this.locales.tryAgainLater);
      }

      return inputValue.inputValue.length < this.props.minSearchLength ? this.locales.termMessage : this.locales.noOptions;
    }
  }, {
    key: "updateValue",
    value: function updateValue(values) {
      this.setState({
        value: values
      });

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(values);
      }
    }
  }]);

  return AsyncSelectMulti;
}(React.Component);

AsyncSelectMulti.defaultProps = {
  disabled: false,
  isMulti: true,
  prefetch: false,
  minSearchLength: 3,
  defaultOptions: [],
  value: []
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    hasError: state["asyncSelectMulti-".concat(ownProps.id)].hasError,
    isDisabled: state["asyncSelectMulti-".concat(ownProps.id)].isDisabled,
    isSearched: state["asyncSelectMulti-".concat(ownProps.id)].isSearched,
    isSearching: state["asyncSelectMulti-".concat(ownProps.id)].isSearching,
    options: state["asyncSelectMulti-".concat(ownProps.id)].options
  };
};

export default connect(mapStateToProps, {
  disabledStateUpdate: disabledStateUpdate,
  optionsUpdate: optionsUpdate,
  searchForOptions: searchForOptions
})(AsyncSelectMulti);